export default __webpack_public_path__ + "static/media/how-to-start.969997d3.gif";